import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getPartiList = createAsyncThunk(
  "get-parti",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("parti/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createParti = createAsyncThunk(
  "create-parti",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("parti", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const editParti = createAsyncThunk(
  "edit-parti",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`parti/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateParti = createAsyncThunk(
  "update-parti",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/parti/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteParti = createAsyncThunk(
  "delete-parti",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/parti/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const partiSlice = createSlice({
  name: "parti",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPartiList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPartiList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.partiList;
        state.perPage = action?.payload?.data?.data?.perPage;
        state.total = action?.payload?.data?.data?.total;
      })
      .addCase(getPartiList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default partiSlice.reducer;
